import React from 'react';
import '../styles/About.css';
import aboutImage from '../assets/about-illustration.png';

export default function About() {
  return (
    
    <div className="about-page container py-5">
      <h1>About Us</h1>
      <div className="row align-items-center g-5">

        {/* Left: Image */}
        <div className="col-lg-6">
          <img
            src={aboutImage}
            alt="About Reans Consulting"
            className="img-fluid rounded shadow-sm"
          />
        </div>

        {/* Right: Text */}
        <div className="col-lg-6">
          <section className="mb-4">
            <h2 className="section-heading">Who We Are</h2>
            <p>
              Reans Consulting Sdn Bhd is a Malaysia-based consultancy firm established in 2020.
              Our mission is to empower businesses to grow their workforce in Malaysia without
              worrying about legal, administrative, or immigration hurdles.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="section-heading">Our Philosophy</h2>
            <p>
              We believe that smart hiring starts with the right partner—one who understands
              local compliance, values talent, and acts quickly. That’s why our services are built
              on the pillars of efficiency, compliance, and personalized support.
            </p>
          </section>

          <section>
            <h2 className="section-heading">Our Office</h2>
            <p>
              56-1-A, Jalan 7A/2, Bandar Tasik Puteri, Kampung Baru Kundang,
              48020 Rawang, Selangor, Malaysia
            </p>
          </section>
        </div>

      </div>
    </div>
  );
}
